// Modo Tablet: APOSENTADO na DA-390. Este modulo ainda existe so pra nao quebrar a chamada em
// main.tsx, mas ficou INERTE de proposito: a classe `.modo-tablet` que ele aplica NAO tem mais
// nenhuma regra em styles.css (o force-hamburguer foi removido), e o toggle "Computador | Tablet"
// saiu do Login e do menu hamburguer. Motivo: a DA-387 D3 colapsava o tablet no hamburguer, mas o
// Ruan quer a BARRA horizontal — hoje o styles.css mostra a barra COMPACTA sozinho em tablet de
// toque (pointer: coarse, 900–1366px), sem depender deste localStorage (que nem era compartilhado
// entre o app PWA e o Chrome do mesmo aparelho). Manter inerte evita que um toggle preso em "Tablet"
// engula a barra. Pode ser removido de vez numa faxina (tirar a chamada de main.tsx tambem).
import { useEffect, useState } from 'react';

const CHAVE = 'modo-tablet';
const EVENTO = 'modo-tablet-mudou';

export function isModoTablet(): boolean {
  try { return localStorage.getItem(CHAVE) === '1'; } catch { return false; }
}

function aplicarClasse(ligado: boolean): void {
  document.documentElement.classList.toggle('modo-tablet', ligado);
}

export function setModoTablet(ligado: boolean): void {
  try { localStorage.setItem(CHAVE, ligado ? '1' : '0'); } catch { /* localStorage indisponivel */ }
  aplicarClasse(ligado);
  window.dispatchEvent(new Event(EVENTO));
}

// Chamado UMA vez no boot (main.tsx), antes do render, pra a classe ja nascer aplicada (sem piscar).
export function aplicarModoTabletInicial(): void {
  aplicarClasse(isModoTablet());
}

// Hook reativo: reflete a troca em qualquer instancia montada (o seletor do Login e o do menu do
// Layout ficam em sincronia via o evento).
export function useModoTablet(): [boolean, (ligado: boolean) => void] {
  const [ligado, setLigado] = useState(isModoTablet());
  useEffect(() => {
    const aoMudar = () => setLigado(isModoTablet());
    window.addEventListener(EVENTO, aoMudar);
    return () => window.removeEventListener(EVENTO, aoMudar);
  }, []);
  return [ligado, setModoTablet];
}
